<template>
	<MicrohabitCategoriesPanelMenu :type="MICROHABIT_SIMPLE_TYPE">
		<template v-slot:header>
			<h2>{{ $t('microhabits.simple.categories-menu.title')}}</h2>
			<p class="mt-3">{{ $t('microhabits.simple.categories-menu.subtitle')}}</p>
		</template>
	</MicrohabitCategoriesPanelMenu>
</template>

<script>
import MicrohabitCategoriesPanelMenu from '@/components/microhabits/MicrohabitCategoriesPanelMenu'
import { MICROHABIT_SIMPLE_TYPE } from '@/constants/microhabitTypes'

export default {
	components: {
		MicrohabitCategoriesPanelMenu
	},
	data () {
		return {
			MICROHABIT_SIMPLE_TYPE
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/webapp/patient/microhabits/SimpleMicrohabitCategoriesPanelMenu.vue